module.exports = __webpack_public_path__ + "static/media/logo-rede-convida-home.29fc42d5.png";